import { render, staticRenderFns } from "./TemplateFontsSettings.vue?vue&type=template&id=3cab77ed&scoped=true&"
import script from "./TemplateFontsSettings.vue?vue&type=script&lang=js&"
export * from "./TemplateFontsSettings.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFontsSettings.vue?vue&type=style&index=0&id=3cab77ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab77ed",
  null
  
)

export default component.exports